import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useEditInvoiceConfigMutation } from 'queries/invoiceConfig/useEditInvoiceConfigMutation'

type EditInvoiceConfigFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useEditInvoiceConfigMutation>['mutate']
    reset: ReturnType<typeof useEditInvoiceConfigMutation>['reset']
  }
}

const [Context, useEditInvoiceConfigFlowContextValue] =
  createContext<EditInvoiceConfigFlowContextState>({
    name: 'EditInvoiceConfigFlowContext',
  })

export const EditInvoiceConfigFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const { mutate, reset, isPending, isError, error } =
    useEditInvoiceConfigMutation()

  const value: EditInvoiceConfigFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useEditInvoiceConfigFlowContextValue }
